<template>
  <div class="maxh-1bar scroll-y pa-3 d-flex">
    <div class="w-1/2 pa-3 d-flex flex-column">
      <AssocWifi ref="assocWifi" :vehicle="value" @reload="reloadStatus" />
    </div>

    <div class="w-1/2 pa-3">
      <WifiEmbedStatus ref="embedStatus" :vehicle="value" />
    </div>
  </div>
</template>

<script>
import AssocWifi from './wifi/AssocWifi.vue'
import WifiEmbedStatus from './wifi/WifiEmbedStatus.vue'

export default {
  expose: ['reload'],
  tabTitle: 'Wifi',
  tabGroup: 'Veículo',
  components: { AssocWifi, WifiEmbedStatus },
  props: {
    value: { required: true }
  },
  methods: {
    emitReload() {
      this.$emit('reload')
    },
    reloadStatus() {
      this.$refs.embedStatus.reload()
    },
    reload() {
      this.$refs.assocWifi.reload()
      this.$refs.embedStatus.reload()
    }
  }
}
</script>

<style></style>
